import { HISTORY_DECIMALS_OUTPUT } from '@/core/config/history'
import { ExchangeHistoryItemInterface } from '@/redux/transactions/transactions.types'
import { DATE_FORMAT, formatDate } from '@/utils/lib/formatDate'
import { truncateNumber } from '@/utils/lib/truncateNumber'

export const dateFormatter = (source: string, format: DATE_FORMAT = DATE_FORMAT.WITH_SECONDS) =>
  formatDate(new Date(Number(source)), format)

export const tryNumberFormatter = (source: string) => {
  const sourceNumber = Number(source)
  if (isNaN(sourceNumber)) return source
  return truncateNumber(sourceNumber, HISTORY_DECIMALS_OUTPUT)
}

export const convertAllValuesToString = (source: ExchangeHistoryItemInterface): Record<string, string> => {
  return Object.entries(source).reduce((acc, [key, value]) => {
    return {
      ...acc,
      [key]: value.toString(),
    }
  }, {})
}
